export enum PlanningItemType {
  MAINTENANCE,
  MACHINE_UNAVAILABLE,
  CREEL_CHANGE,
  WARP_CHANGE,
  RUN
}
